// extracted by mini-css-extract-plugin
export default {"container":"Ck-z","blurb":"Dk-z","links":"Ek-z"};